import React from "react";
import { Heading, Subheading } from "../design/heading";

interface Props {
  title: string;
  message?: string;
}

const EmptyStateView: React.FC<Props> = ({ title, message }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <Heading>{title}</Heading>
      {message && <Subheading>{message}</Subheading>}
    </div>
  );
};

export default EmptyStateView;
